import request from '@/utils/request';

/* eslint-disable */
const actions = {
  async addFaq({ dispatch, commit, rootGetters }, faq) {
    try {
      const { data } = await request.post('/faqs', faq);

      if (data.error) {
        throw Error('Server-side validation failed');
      }
    } catch (err) {
      throw err;
    }
  },
};

export default actions;
